/**
 * @generated SignedSource<<5e051020bb4e8006d62f9ba8bdfa5a60>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphDesign_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly __typename: "ExternalDesign";
    readonly thumbnail: {
      readonly externalUrl: string | null | undefined;
    } | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly permissionLevel: string | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphDesign_AtlassianSearchPage";
};
export type searchGraphDesign_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphDesign_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphDesign_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = {
  "kind": "ScalarField",
  "name": "url"
},
v4 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphDesign_AtlassianSearchPage",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "permissionLevel"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "concreteType": "ExternalThumbnail",
              "kind": "LinkedField",
              "name": "thumbnail",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "externalUrl"
                }
              ]
            }
          ],
          "type": "ExternalDesign"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v4/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "33e7c4704ea491a336bc35c0ecdefe69";

export default node;
